import axios from '@/utilities/axios-global'

export function GET_DOCUMENTS(context, directory) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + '/documents?directory=' + directory).then(
      response => {
        context.commit('SET_DOCUMENTS', response.data)
        resolve()
      },
      error => {
        console.log(error)
        context.commit('SET_DOCUMENTS', [])
        reject(error)
      }
    )
  })
}

export function POST_DOCUMENT(context, payload) {
  return new Promise((resolve, reject) => {
    if (payload.attachment.size > 1073741824) {
      // eslint-disable-next-line
      reject({
        response: {
          data: { message: 'Files size cannot be greater than 1 GB' }
        }
      })
      return
    }

    // we need to use a special endpoint and FormData here
    // to make the browser stream the file directly to the server instead
    // of storing it in local memory
    let formData = new FormData()
    formData.append('attachment', payload.attachment)
    formData.append('name', payload.name)
    if (payload.fileNameExceptionReason) {
      formData.append('fileNameExceptionReason', payload.fileNameExceptionReason)
    }
    formData.append('directory', payload.directory)

    axios
      .post(context.rootState.user.baseApiUrl + '/documents/file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: payload.onUploadProgress
      })
      .then(
        response => {
          context.commit('PUSH_DOCUMENT', response.data)
          resolve(response)
        },
        error => {
          console.log(error)
          reject(error)
        }
      )
  })
}

export function POST_FOLDER(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + '/documents/folder', payload).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function DELETE_DOCUMENT(context, document) {
  return new Promise((resolve, reject) => {
    axios
      .delete(context.rootState.user.baseApiUrl + '/documents/' + document.id, {
        onDownloadProgress: document.onDownloadProgress
      })
      .then(
        response => {
          context.commit('REMOVE_DOCUMENT', document.id)
          resolve(response)
        },
        error => {
          console.log(error)
          reject(error)
        }
      )
  })
}

export function GET_SUBDIRECTORIES(context, directoryName) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/documents/subdirectories?directoryName=${encodeURIComponent(directoryName)}`).then(
      response => {
        context.commit('SET_MOVEACTION_SUBDIRECTORIES', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function MOVE_DOCUMENT(context, document) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/documents/${document.id}`, document, { onUploadProgress: document.onUploadProgress }).then(
      response => {
        context.commit('REMOVE_DOCUMENT', document.id)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function COPY_DOCUMENT(context, document) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/documents/copy/${document.id}`, document, { onUploadProgress: document.onUploadProgress }).then(
      response => {
        // context.commit('REMOVE_DOCUMENT', document.id)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DOWNLOAD_LINK(context, id) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + '/documents/download-link/' + id).then(
      response => {
        // push the download history so that it will display without refresh
        let newDownloadHistory = {
          email: context.rootState.user.user.email,
          downloadDate: new Date().getTime(),
          documentId: id
        }
        context.commit('PUSH_DOWNLOAD_HISTORY', newDownloadHistory)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function DOWNLOAD_MULTIPLE(context, payload) {
  return new Promise((resolve, reject) => {
    axios
      .post(context.rootState.user.baseApiUrl + `/documents/downloadmultiple?currentDirectory=${payload.currentDirectory}`, payload.documents, {
        responseType: 'arraybuffer',
        onDownloadProgress: payload.onDownloadProgress
      })
      .then(
        response => {
          // push the download history so that it will display without refresh
          for (let i = 0; i < payload.documents.length; i++) {
            if (!payload.documents[i].isFolder) {
              let newDownloadHistory = {
                email: context.rootState.user.user.email,
                downloadDate: new Date().getTime(),
                documentId: payload.documents[i].id
              }
              context.commit('PUSH_DOWNLOAD_HISTORY', newDownloadHistory)
            }
          }
          resolve(response)
        },
        error => {
          console.log(error)
          reject(error)
        }
      )
  })
}

export function POST_ZIPBUILDER(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/documents/zipbuilder?currentDirectory=${payload.currentDirectory}&displayDirectory=${payload.displayDirectory}`, payload.documents).then(
      response => {
        // push the download history so that it will display without refresh
        for (let i = 0; i < payload.documents.length; i++) {
          if (!payload.documents[i].isFolder) {
            let newDownloadHistory = {
              email: context.rootState.user.user.email,
              downloadDate: new Date().getTime(),
              documentId: payload.documents[i].id
            }
            context.commit('PUSH_DOWNLOAD_HISTORY', newDownloadHistory)
          }
        }
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function PUT_RENAMEDOCUMENT(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + '/documents/rename', payload).then(
      response => {
        context.commit('PUT_DOCUMENT', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export default {
  GET_DOCUMENTS,
  GET_DOWNLOAD_LINK,
  POST_DOCUMENT,
  POST_FOLDER,
  DELETE_DOCUMENT,
  GET_SUBDIRECTORIES,
  MOVE_DOCUMENT,
  DOWNLOAD_MULTIPLE,
  PUT_RENAMEDOCUMENT,
  POST_ZIPBUILDER,
  COPY_DOCUMENT
}
